import { motion } from "framer-motion";
import styled, { keyframes } from "styled-components";
import config from "../../config.json";
import { getCommissionStatus } from "../../lib";
import { theme } from "../../styles";
import { Banner, Button, ButtonIcon, Logo, Footer } from "../../components";
import { Header } from "./style";
import Nav from "./HomeNav";
import { StylusIcon, StylusNoteIcon } from "../../assets/svg";
import { Link } from "react-router-dom";

const Home = () => {
  const commStatus = getCommissionStatus();

  return (
    <>
      <Banner />
      <Header>
        <Logo size="3rem" />
        {/* <motion.p
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(theme.delayMd)}
          style={{ whiteSpace: "pre-line" }}
        >
          {config.introduction}
        </motion.p> */}
      </Header>
      <Nav />
      {commStatus.includes("open") && (
        <Button
          type="Link"
          color="brand"
          size="lg"
          width="fit-content"
          to="/request"
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(theme.delayXl)}
          swapChildren={
            <>
              {config.slotsFilled}/{config.slotsOpen} slots open
              <ButtonIcon>
                <StylusNoteIcon />
              </ButtonIcon>
            </>
          }
        >
          Request a{" "}
          {commStatus.includes("open") &&
            !commStatus.includes("sketchonly") &&
            !commStatus.includes("vtuberonly") &&
            "commission"}
          {commStatus.includes("sketchonly") && "sketch"}
          {commStatus.includes("vtuber") && "VTuber"}
          <ButtonIcon>
            <StylusIcon />
          </ButtonIcon>
        </Button>
      )}
      <ClientLink to="/clients">
      <motion.p
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(theme.delayMd)}
        >
          See all clients
        </motion.p>
        <MarqueeWrapper>
          <ClientMarquee>
            {Array(
              [...config.clients].map((client, ind) => (
                <ClientProfile
                  src={require(`../../assets/clients/${client.name}/profile.png`)}
                  key={`client-profile-${ind}`}
                />
              ))
            )}
          </ClientMarquee>
        </MarqueeWrapper>
        
      </ClientLink>
      <Footer />

      

    </>
  );
};

export default Home;

const ClientLink = styled(Link)`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: ${props => props.theme.sizeSmall};
  gap: ${props => props.theme.spaceMd};
  text-align: center;
  text-transform: uppercase;
  

  &:hover {
    p {

    color: ${props => props.theme.brand};
    }
  }

  p {
    color: ${props => props.theme.mutedColor};
  }
`

const MarqueeWrapper = styled.div`
  position: relative;
  max-width: calc(6 * 2rem + (1rem * 7));
  width: 100%;
  overflow-x: hidden;
  margin: 0 auto;

  &:before {
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;

    position: absolute;
    content: '';
    background: linear-gradient(to right, ${props => props.theme.backgroundColor} 0%, ${props => props.theme.backgroundColor}00 50%, ${props => props.theme.backgroundColor} 100%);
    z-index: 5;
  }
`;

const scroll = keyframes`
  0% {
    transform: translateX(-200%);
    opacity: 0;
  }
  5% {
  opacity: 1;
  }
  95% {
  opacity: 1  
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const ClientMarquee = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spaceMd};
  animation: ${scroll} 20s linear infinite;
`;

const ClientProfile = styled.img`
  height: 5rem;
  width: 5rem;
  border-radius: ${(props) => props.theme.borderFull};
`;
